import * as React from 'react';

import ExtendsContextMenuItem from './ExtendsContextMenuItem';

import type { ContextMenuItem } from 'types';

type Props = {
  item: ContextMenuItem,
  onModalClosed?: (a: React.MouseEvent) => void
};

class ContextMenuItemGeneric extends ExtendsContextMenuItem<Props> {
  render() {
    const { item } = this.props;

    return (
      <React.Fragment>
        {this.renderIcon(item)}
        <div className="context-menu-item__text">
          {item.text}
        </div>
        {
          item.hasNotification &&
            <div className="context-menu-item__notification" />
        }
      </React.Fragment>
    );
  }
}

export default ContextMenuItemGeneric;
